export interface OrganizationSettings {
    organizationId: string;
    extensions: [OrganizationExtensions];
    layout: LayoutSettings;
    responses: any[];
    scripts: Scripts[];
    styles: Styles[];
    helpCenter?: HelpCenter;
}

export interface HelpCenter {
    url: string,
    articles: { [key: string]: string },
}

export enum ScriptType {
    'inline' = 'inline',
    'external' = 'external',
}

export interface Scripts {
    type: ScriptType,
    data: string,
}

export interface Styles {
    path: string;
}

interface Logo {
    transparent: string;
    original: string;
}

export interface LayoutSettings {
    logo: Logo;
    color: string;
    title: string;
}

export interface OrganizationExtensions {
    extension: Extensions;
    enable: boolean;
}

export enum Extensions {
    'dashboard' = 'dashboard',
    'transboard' = 'transboard',
    'faq' = 'faq',
    'user' = 'user',
    'integrations' = 'integrations',
    'entities' = 'entities',
    'workspace' = 'workspace',
    'live-agent' = 'live-agent',
}

export interface ResponseTypes {
    name: string;
    title: string;
    icon: string;
    options: ResponseOptions;
}

export interface ResponseOptions {
    name: string;
    responses: Response[];
}

export interface Response {
    type: string;
    name: string;
    title: string;
    icon: string;
    action: string;
}